import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Calendar, MessageCircle } from 'lucide-react';

const Articles = () => {
  useEffect(() => {
    document.title = 'Makaleler | akarma - Banu Gökcül';
  }, []);

  const articles = [
    {
      title: 'Zengin olmak mı istiyorsunuz?',
      date: '12 Ekim 2018',
      slug: 'zengin-olmak',
      image: 'https://akarma.com.tr/upload/akarma/parayi-bollukla-hayatina-cek.jpg',
      excerpt: 'Zengin olmak mı istiyorsunuz? Tamam! Öyleyse, zihinsel sürecinizin hayali değerini belirlemek için, basit bir zihinsel monopoly oyunu oynayalım. Diyelim ki sahip olduğunuz her...',
      comments: 2,
      content: 'Para ve bolluk üzerine zihinsel programlamalarımız, zenginlik bilincimiz ve parayla ilişkimiz hayatımızı şekillendiren en önemli unsurlardandır. NLP teknikleri ile bilinçaltımızdaki sınırlayıcı inançları değiştirerek bolluk bilincine ulaşabiliriz.'
    },
    {
      title: 'Avatarın Sonbahar Ayılmaları',
      date: '12 Eylül 2018',
      slug: 'avatar-sonbahar-ayilmalari',
      image: 'https://akarma.com.tr/upload/akarma/b2.jpg',
      excerpt: 'Algı Herşeydir (!) Kendin Olmak: "Hiç kimse bakmıyorken kimsin" Sonundaki eksersizi yapmanızı hayaretle tavsiye ederim. Etki etme, etkileme. En güçlü silahımız. Özgün bir tavır...',
      comments: 5,
      content: 'Farkındalık yolculuğumuzda, öz benliğimizi keşfetmek ve otantik olmak hayatımızın en büyük hediyesidir. Sonuç odaklı yaşamak yerine süreç odaklı yaşamayı öğrenmek, her anı dolu dolu yaşamamayı sağlar.'
    },
    {
      title: 'BİLİŞSEL TEDAVİ',
      date: '12 Ağustos 2018',
      slug: 'bilissel-tedavi',
      image: 'https://akarma.com.tr/upload/akarma/b3.jpg',
      excerpt: 'Bilişsel tedavi Aaron Beck tarafından ortaya konulmuştur. Bu tedavi, kişilerin duygu ve davranışlarının kendi oluşturdukları dünya ve yaşantı ile büyük ölçüde belirlenmesi...',
      comments: 13,
      content: 'Bilişsel terapi yaklaşımı, düşünce-duygu-davranış üçgeninin anlaşılması ve dönüştürülmesi üzerine kurulmuştur. Otomatik düşüncelerimizi fark etmek ve yeniden yapılandırmak, duygusal sağlığımız için kritik önem taşır.'
    }
  ];

  return (
    <div className="articles pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <FileText size={64} className="mx-auto mb-6" />
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Makaleler</h1>
            <p className="text-xl md:text-2xl opacity-90">
              Kişisel gelişim, psikoloji ve yaşam koçluğu üzerine yazılar
            </p>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {articles.map((article, index) => (
                <Link 
                  key={index} 
                  to={`/makaleler/${article.slug}`}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden card-hover block"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <Calendar size={16} className="mr-2" />
                      {article.date}
                    </div>
                    <h2 className="text-2xl font-bold mb-3 text-gray-900 hover:text-akarma-blue transition-colors">{article.title}</h2>
                    <p className="text-gray-600 mb-4 leading-relaxed">{article.excerpt}</p>
                    <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                      <div className="flex items-center text-gray-500">
                        <MessageCircle size={18} className="mr-2" />
                        <span>{article.comments} yorum</span>
                      </div>
                      <span className="text-akarma-blue font-medium">Devamını Oku →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Article Details Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Popüler Konular</h2>
            <div className="space-y-8">
              {articles.map((article, index) => (
                <div key={index} className="bg-white p-8 rounded-2xl shadow-lg">
                  <h3 className="text-2xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-akarma-blue to-akarma-blue-700">
                    {article.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">{article.content}</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <Calendar size={16} className="mr-2" />
                    {article.date}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Topics Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">İçerik Konuları</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                'NLP ve Kişisel Gelişim',
                'Liderlik ve Yönetim',
                'Duygusal Zeka',
                'Stres Yönetimi',
                'İlişki Yönetimi',
                'Farkındalık ve Meditasyon',
                'Motivasyon ve Başarı',
                'Bilişsel Terapi',
                'Bolluk Bilinci',
                'Mutluluk Psikolojisi',
                'Yaratıcılık ve İnovasyon',
                'Özgüven ve Öz Değer'
              ].map((topic, index) => (
                <div key={index} className="flex items-center space-x-3 bg-gradient-to-r from-blue-50 to-purple-50 p-4 rounded-xl">
                  <div className="w-8 h-8 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                    <FileText size={18} className="text-white" />
                  </div>
                  <span className="text-gray-700 font-medium">{topic}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-5xl font-bold mb-2">100+</div>
                <div className="text-xl opacity-90">Yayınlanmış Makale</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">4</div>
                <div className="text-xl opacity-90">Kitap</div>
              </div>
              <div>
                <div className="text-5xl font-bold mb-2">20+</div>
                <div className="text-xl opacity-90">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter / Contact */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Daha Fazla İçerik İçin</h2>
            <p className="text-xl text-gray-600 mb-8">
              Kişisel gelişim, liderlik ve yaşam koçluğu üzerine daha fazla bilgi almak için 
              bizimle iletişime geçebilir veya kitaplarımızı inceleyebilirsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/kitaplar"
                className="px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
              >
                Kitapları İncele
              </a>
              <a
                href="/iletisim"
                className="px-8 py-4 bg-white border-2 border-akarma-blue text-akarma-blue rounded-full font-semibold hover:bg-blue-50 transition-all duration-300"
              >
                İletişime Geç
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Articles;